export const BEARER = "Bearer "
export const AUTHORIZATION = "Authorization"
export const REFRESH_TOKEN = "refresh_token"
export const ACCESS_TOKEN = "access_token"
export const VERIFICATION_QUERY = "verification"
export const NEW_ROOM_MENU = "newRoomMenu"
export const APP_MENU = "appMenu"
export const PROFILE = "PROFILE"
export const NOTIFICATION_LIST = "notifications"
export const MAIN_WINDOWS = "MAIN_WINDOW"
export const NEW_ROOM = "newRoom"
export const ADD_TO_CHAT_PAGE="addToChat"
export const REMOVE_ROOMS="REMOVE_ROOMS"


export const LOGIN_PAGE = "login"
export const REGISTRATION_PAGE = "registration"

export const IDLE = "idle"
export const LOADING = "loading"
export const SUCCEEDED = "succeeded"
export const FAILED = "failed"
export const REFRESH = "refresh"

export const OBSOLETE = "OBSOLETE"

export const REMEMBERME = "REMEMBERME"
export const CSRF_HEADER_NAME = "X-CSRF-TOKEN"

export const NEW_CONTACT = "NewContact"
export const CONTACT_ACCEPT = "ContactAccept"
export const CONTACT_DECLINE = "ContactDecline"

